import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Card from '@gef-ui/components/atoms/SvgIcon/Icons/Card';

import { getRoutePath } from 'utils';

const ContactCard = ({ id }) => {
	const handleStopPropagation = useCallback((e) => {
		e.stopPropagation();
	}, []);

	const { pathname, state } = getRoutePath('contactDetail', { contactId: id }, true);
	return (
		<Link to={pathname} state={state} onClick={handleStopPropagation}>
			<Card className="ContactCard" />
		</Link>
	);
};

ContactCard.propTypes = {
	id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
export default ContactCard;
